import React from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import constructions from "../assets/image/happy/construction.png";

const Error404 = ({}) => {

    return (
        <Layout>
            <div className="vh-100 flex justify-center items-center">
                <div className="relative">
                    <div className="absolute top-0 w-100 text-center mt-3">
                        <h1 className="text-black">No encontrado</h1>
                    </div>
                </div>
            </div>
        </Layout>
    );
};


const mapStateToProps = state => ({})

export default connect(mapStateToProps, {})(Error404)
